import { gql } from '@apollo/client';

export const GetConsentPoliciesQuery = gql`
  query GetConsentPoliciesQuery($ids: [ID!]) {
    consentPolicies(where: { id: { in: $ids } }) {
      id
      content {
        document
      }
    }
  }
`;
